import React from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,

  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  TelegramIcon
} from 'react-share'
import '../scss/SharePanel.css'

const SharePanel = (props) => {
  const url = window.location.protocol + '//' + window.location.hostname + props.url

  return <div className={'share-panel'} onClick={props.close}>
    {/*
    <div className={'share-panel__header'}>
      <IconClose onClick={props.close}
        width={32} height={32} className={'share-panel__close'} />
    </div>
    */ }

    <div className={'share-panel__buttons'}>
      <FacebookShareButton url={url} quote={props.title} className={'share-panel__button'}>
        <FacebookIcon />
      </FacebookShareButton>

      <TwitterShareButton url={url} title={props.title} className={'share-panel__button'}>
        <TwitterIcon />
      </TwitterShareButton>

      <WhatsappShareButton url={url} title={props.title} className={'share-panel__button'}>
        <WhatsappIcon />
      </WhatsappShareButton>

      <TelegramShareButton url={url} title={props.title} className={'share-panel__button'}>
        <TelegramIcon />
      </TelegramShareButton>
    </div>
  </div>
}

export default SharePanel



// WEBPACK FOOTER //
// ./src/components/SharePanel.js